import RefreshRounded from "@mui/icons-material/RefreshRounded";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import ToggleButton from "@mui/material/ToggleButton";
import { useTranslation } from "react-i18next";
import { ResultInput } from "./grid/filter/ResultInput";
import { UserSelect } from "./grid/filter/UserSelect";
import { UserTypeInput } from "./grid/filter/UserTypeInput";
import { Banner } from "@/components/branding/Banner";

interface Props {
  onResultChange?(result: string[]): void;
  onUserTypeChange?(userType: string[]): void;
  onUserChange(value?: string): void;
  toggleDetailedView(): void;
  detailedView: boolean;
  refresh: () => void;
  isMobile?: boolean;
}

export function FilterBar({
  onResultChange,
  onUserChange,
  onUserTypeChange,
  toggleDetailedView,
  detailedView,
  refresh,
  isMobile,
}: Props) {
  const { t } = useTranslation();
  return (
    <Stack
      sx={{
        pl: 2,
        pr: 2,
        py: 2,
        minHeight: 32,
        justifyContent: "space-between",
      }}
      gap={2}
      direction={"row"}
    >
      <Stack
        flexGrow={1}
        gap={2}
        direction={isMobile ? "column" : "row"}
        maxWidth={isMobile ? "100%" : "80%"}
      >
        <UserSelect onChange={onUserChange} />
        <ResultInput onChange={onResultChange} />
        <UserTypeInput onChange={onUserTypeChange} />

        <ToggleButton
          size="small"
          color="info"
          value="uncheck"
          selected={detailedView}
          onChange={toggleDetailedView}
        >
          {t("detailedView", "Detailed View")}
        </ToggleButton>

        <Button variant="outlined" onClick={refresh}>
          <RefreshRounded />
        </Button>
      </Stack>
      {!isMobile && (
        <Stack gap={2} direction="row">
          <Divider orientation="vertical" />
          <Banner width={150} />
        </Stack>
      )}
    </Stack>
  );
}
